import { axios } from './axios'
import { _url } from './http'
import store from '@store/index.js'
import snakeObject from '../utils/snakeObject'
export default {
    get: (url, payload = {}) => {
        payload = setUserPerson(payload)
        const totalUrl = url + querify(snakeObject(payload))
        return axios.get(_url(totalUrl))
    },
    post: (url, payload = {}, config = {}) => {
        payload = setUserPerson(payload)
        return axios.post(_url(url), snakeObject(payload), config)
    },
    put: (url, payload, config = {}) => {
        payload = setUserPerson(payload)
        return axios.post(_url(url), putMethod(snakeObject(payload)), config)
    },
    delete: (url, payload, config = {}) => {
        const queryString = querify(snakeObject(payload))
        const glue = !!queryString ? '&' : '?'
        const totalUrl =
            url + queryString + glue + `current_user_id=${store.getters.currentUser?.id}` + glue + `current_person_id=${store.getters.currentPerson?.id}`
        return axios.delete(_url(totalUrl), config)
        // return axios.post(totalUrl);
    },
    querify: (params) => querify(params),
}

const putMethod = (payload) => {
    if (isFormData(payload)) {
        payload.append('_method', 'PUT')
    } else {
        payload['_method'] = 'PUT'
    }
    return payload
}

const isObject = (o) => {
    return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

const isArray = (o) => {
    return Array.isArray(o)
}

const setUserPerson = (payload) => {
    const userId = store.getters.currentUser?.id

    if (isFormData(payload)) {
        !!userId && payload.append('current_user_id', userId)
        return payload
    }

    !!userId && ((payload ?? {}).currentUserId = userId)

    return payload
}

const isFormData = (o) => o instanceof FormData

const querify = (params) => {
    if (!params || !Object.keys(params).length) return ''
    const arrParams = []
    Object.keys(params).map(
        (key) => typeof params[key] !== 'undefined' && params[key] !== '' && params[key] !== null && arrParams.push(paramValue(key, params))
    )
    const union = !!arrParams.length ? '?' : ''
    const queryString = union + arrParams.join('&')
    return queryString
}
const paramValue = (key, data) => {
    if (Array.isArray(data[key])) {
        return `${key}=${data[key].join(',')}`
    }
    return `${key}=${data[key]}`
}
